export default "__VITE_ASSET__CRe3OZCZ__"